import { useMutation } from '@tanstack/react-query';

import { updateBusinessProfile } from '../api/businessProfileApi';
import { useBusinessSettingsStore } from '../store/businessSettingsStore';
import type { UpdateProfileRequest } from '../types';

export function useBusinessProfile() {
  const accountId = useBusinessSettingsStore((s) => s.account?.accountId);

  const mutation = useMutation({
    mutationFn: (request: UpdateProfileRequest) => {
      if (!accountId) throw new Error('Account ID not found');
      return updateBusinessProfile(accountId, request);
    },
  });

  return {
    submitProfile: mutation.mutate,
    isPending: mutation.isPending,
  };
}
